import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck, CheckCircle2, XCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const EmailTest = () => {
  const [mailbox, setMailbox] = useState(null);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/email-test").then((r) => setMailbox(r.data.mailbox)); }, []);
  const send = async () => {
    setBusy(true); setRes(null);
    try {
      const { data } = await api.post("/admin/email-test");
      setRes(data);
      data.ok ? toast.success("Email di prova inviata") : toast.error("Invio non riuscito");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-black/10 bg-white p-5" data-testid="email-test">
      <div className="min-w-0">
        <h2 className="font-display text-lg font-bold">Prova invio email</h2>
        <p className="text-sm text-stone-600">Invia un'email di prova tramite Aruba alla casella collegata{mailbox && <> <b data-testid="email-test-mailbox">{mailbox}</b></>}.</p>
        {res && (
          <p className={`mt-2 flex items-center gap-1.5 text-sm font-semibold ${res.ok ? "text-emerald-700" : "text-rose-600"}`} data-testid="email-test-result">
            {res.ok ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}{res.message}
          </p>
        )}
      </div>
      <button onClick={send} disabled={busy || !mailbox} className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-5 py-2.5 text-sm font-bold text-black transition-colors hover:bg-amber-400 disabled:opacity-60" data-testid="email-test-send">
        <MailCheck className="h-4 w-4" />{busy ? "Invio..." : "Invia email di prova"}
      </button>
    </div>
  );
};
